var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box } from "@mui/material";
import { BODY_TEXT_COLOR, DIMMED_OPACITY } from "../utils/chartConstants";
import { formatNumericValue } from "../../../utils/chartData";
import Sparkline from "./Sparkline";
var DeamsLegendCards = function (_a) {
    var items = _a.items, selectedSeries = _a.selectedSeries, onItemClick = _a.onItemClick, onClear = _a.onClear, showAll = _a.showAll, onToggleShowAll = _a.onToggleShowAll, canToggle = _a.canToggle;
    return (_jsxs(Box, __assign({ sx: { mt: 1 } }, { children: [_jsxs(Box, __assign({ sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    mb: 2,
                    flexWrap: "wrap",
                } }, { children: [_jsx(Box, __assign({ sx: {
                            fontFamily: "Montserrat, sans-serif",
                            fontSize: "0.82rem",
                            fontWeight: 600,
                            color: "#6B7280",
                        } }, { children: showAll ? "Todos os territórios" : "Principais territórios" })), _jsxs(Box, __assign({ sx: { display: "flex", alignItems: "center", gap: 1 } }, { children: [canToggle && (_jsx(Box, __assign({ component: "button", type: "button", onClick: onToggleShowAll, "data-testid": "deams-toggle-cards", sx: {
                                    border: "1px solid #D1D5DB",
                                    background: "#fff",
                                    color: "#374151",
                                    borderRadius: "999px",
                                    px: 1.25,
                                    py: 0.45,
                                    fontFamily: "Montserrat, sans-serif",
                                    fontSize: "0.72rem",
                                    fontWeight: 700,
                                    cursor: "pointer",
                                } }, { children: showAll ? "Mostrar menos" : "Ver todos os territórios" }))), selectedSeries.length > 0 && (_jsx(Box, __assign({ component: "button", type: "button", onClick: onClear, sx: {
                                    border: "1px solid #D1D5DB",
                                    background: "#fff",
                                    color: "#374151",
                                    borderRadius: "999px",
                                    px: 1.25,
                                    py: 0.45,
                                    fontFamily: "Montserrat, sans-serif",
                                    fontSize: "0.72rem",
                                    fontWeight: 700,
                                    cursor: "pointer",
                                } }, { children: "Limpar" })))] }))] })), _jsx(Box, __assign({ sx: {
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, minmax(0, 1fr))",
                        md: "repeat(3, minmax(0, 1fr))",
                        xl: "repeat(5, minmax(180px, 1fr))",
                    },
                    gap: 2,
                } }, { children: items.map(function (item) {
                    var isSelected = selectedSeries.includes(item.name);
                    var isDimmed = selectedSeries.length > 0 && !isSelected;
                    return (_jsxs(Box, __assign({ component: "button", type: "button", onClick: function () { return onItemClick(item.name); }, sx: {
                            border: "1px solid ".concat(isSelected ? item.color : "#E5E7EB"),
                            borderRadius: "10px",
                            background: isSelected ? "".concat(item.color, "12") : "#fff",
                            p: "14px 16px",
                            minHeight: 84,
                            cursor: "pointer",
                            textAlign: "left",
                            opacity: isDimmed ? DIMMED_OPACITY : 1,
                            transition: "all 0.18s ease",
                        } }, { children: [_jsxs(Box, __assign({ sx: { display: "flex", alignItems: "center", gap: 1, mb: 1 } }, { children: [_jsx(Box, { sx: {
                                            width: 10,
                                            height: 10,
                                            borderRadius: "999px",
                                            background: item.color,
                                            flexShrink: 0,
                                        } }), _jsx(Box, __assign({ sx: {
                                            fontFamily: "Montserrat, sans-serif",
                                            fontSize: "0.875rem",
                                            fontWeight: 600,
                                            color: BODY_TEXT_COLOR,
                                            lineHeight: 1.35,
                                            minWidth: 0,
                                            wordBreak: "break-word",
                                        } }, { children: item.name }))] })), _jsxs(Box, __assign({ sx: {
                                    display: "flex",
                                    alignItems: "flex-end",
                                    justifyContent: "space-between",
                                    gap: 1,
                                } }, { children: [_jsx(Sparkline, { points: item.points, color: item.color }), _jsx(Box, __assign({ sx: {
                                            fontFamily: "Montserrat, sans-serif",
                                            fontSize: "1.125rem",
                                            fontWeight: 700,
                                            color: BODY_TEXT_COLOR,
                                            whiteSpace: "nowrap",
                                        } }, { children: formatNumericValue(item.value) }))] }))] }), item.name));
                }) }))] })));
};
export default DeamsLegendCards;
